import { useMutation, useQueryClient } from 'react-query';

import { taskApi } from 'src/Services/API';
import { trackEvent } from 'src/Services/Matomo';
import { CreateTaskDto } from 'src/types/task.types';

const useCreateTask = (assetId: string) => {
  const queryClient = useQueryClient();

  return useMutation((data: CreateTaskDto) => taskApi.create(assetId, data), {
    onSuccess: () => {
      trackEvent('Task', 'create');
      queryClient.invalidateQueries(['tasks', assetId]);
      queryClient.invalidateQueries(['my-tasks']);
    },
  });
};

export default useCreateTask;
